import Facebook from './facebook.js'
import Google from './google.js'
import Sift from './sift.js'
import Satismeter from './satismeter.js'
import Segment from './segment.js'

function install(user, definitions) {
  if (!user || !definitions) {
    throw new Error('Missing required parameters to install user analytics tracking')
  }

  const thirdParties = [
    { service: Google, installParams: user.id },
    { service: Segment, installParams: { segmentKey: definitions?.segment_js_source_write_key } },
    { service: Facebook, installParams: { user } },
    {
      service: Sift,
      installParams: {
        userId: user?.id,
        accountId: definitions?.sift_beacon_key,
        siftSessionId: definitions?.login_tracking_beacon,
      },
    },
    { service: Satismeter, installParams: { user, satismeterKey: definitions?.satismeter_key } },
  ]

  thirdParties.forEach((party) => {
    const { service, installParams } = party
    service.allowTracking = definitions.enable_user_analytics === true && navigator.doNotTrack !== '1'
    service.isHijackedByAdmin = !!definitions?.hijacked?.is_hijacked
    service.isStaff = !!user?.is_staff
    service.install(installParams)
  })
}

export default { install }
export { Segment, Facebook, Google, Satismeter, Sift }
